<template>
  <pdf-viewer pdf_url="user_agreement_qwello" />
</template>

<script>
import PdfViewer from '../components/shared/PdfViewer.vue';

export default {
  components: {
    PdfViewer,
  },
};
</script>
